import queryString from "query-string";

import { DeviceFields } from "../../../../api/graphql/devices/devices";

export type DeviceNavigationSourceType = "room" | "wayFinder";

export interface DeviceNavigationContext {
  sourceType: DeviceNavigationSourceType;
  sourceId: string;
  deviceId: string;
}

const isDeviceNavigationSourceType = (
  value: unknown
): value is DeviceNavigationSourceType =>
  value === "room" || value === "wayFinder";

export const buildDeviceNavigationUrl = (
  devicesPath: string,
  { sourceType, sourceId, deviceId }: DeviceNavigationContext
): string =>
  `${devicesPath}?${queryString.stringify({ sourceType, sourceId, deviceId })}`;

export const parseDeviceNavigationContext = (
  search: string
): DeviceNavigationContext | undefined => {
  const { sourceType, sourceId, deviceId } = queryString.parse(search);

  if (
    !isDeviceNavigationSourceType(sourceType) ||
    typeof sourceId !== "string" ||
    sourceId.length === 0 ||
    typeof deviceId !== "string" ||
    deviceId.length === 0
  ) {
    return undefined;
  }

  return { sourceType, sourceId, deviceId };
};

export const filterDevicesByNavigationContext = (
  devices: DeviceFields[],
  context?: DeviceNavigationContext
): DeviceFields[] => {
  if (!context) {
    return devices;
  }

  return devices.filter((device) =>
    context.sourceType === "room"
      ? device.room?.id === context.sourceId
      : device.wayFinder?.id === context.sourceId
  );
};
